module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-17.412d4a12.png";